<script setup>
const props = defineProps({
  label: {
    type: String,
    required: false,
    default: null
  },
  prefix: {
    type: String,
    required: false,
    default: null,
  }
});

function getFieldName(name) {
  if (props.prefix) {
    return `${props.prefix}.${name}`;
  }

  return name;
}
</script>

<template>
  <div class="ce-addressForm">
    <div
      v-if="label"
      class="ce-addressForm-label">
      {{ label }}
    </div>

    <div class="ce-addressForm-inner">
      <validated-input
        :name="getFieldName('name')"
        :label="$t('addressForm.name')"
        rules="required" />

      <validated-input
        :name="getFieldName('street')"
        :label="$t('addressForm.street')"
        rules="required" />

      <div class="xs-flex">
        <validated-input
          class="xs-col-3 xs-pr2"
          :name="getFieldName('zipCode')"
          :label="$t('addressForm.zipCode')"
          rules="required" />

        <validated-input
          class="xs-col-9 xs-pl2"
          :name="getFieldName('city')"
          :label="$t('addressForm.city')"
          rules="required" />
      </div>

      <country-select
        :name="getFieldName('country')"
        rules="required"
        :label="$t('addressForm.country')" />
    </div>
  </div>
</template>

<style lang="less">
  @import (reference) "~styles/includes/base";

  .ce-addressForm {
    margin-bottom: @space-3;

    .ce-addressForm-label {
      margin-bottom: @space-2;
      .ms(1);
      .bold;
    }

    .ce-addressForm-inner {
      background: @color-mono-92;
      padding: @space-3;
      border-radius: @border-radius;

      .ce-field {
        input[type="text"], input[type="email"], input[type="number"], input[type="search"], select, textarea {
          background: @color-mono-100;
          border-color: @color-mono-100;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
